























































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  getFirstRouterMap,
  getSecondRouterMap,
  getGroupRouterList
} from '@/api/permission/index'
import {
  addFirstRouter,
  addSecondRouter,
  addApiRouter,
  IAddApi,
  deleteFirstRouter,
  deleteSecondRouter,
  deleteApiRouter,
  getApiRouter,
  updateFirstRouter,
  updateSecondRouter,
  updateApiRouter
} from '@/api/permission/permission-manage/manage'
import { generateTree } from '@/utils/routerTree'
import { cloneDeep } from 'lodash'
import { Form } from 'element-ui'

@Component({
  name: 'PermissionManage'
})
export default class extends Vue {
  tableLoading = false
  treeList: any[] = []
  NODE_KEY = 'id'
  defaultProps = {
    // 默认设置
    children: 'children',
    label: 'name'
  }
  initNode = {
    // 新增参数
    id: '',
    name: '',
    pid: '',
    isEdit: false,
    children: []
  }
  routerList: any = {}
  firstRouter: any = {}
  secondRouter: any = {}
  firstFormVisible = false
  firstParams = {
    name: ''
  }
  secondFormVisible = false
  secondParams = {
    firstId: '',
    name: ''
  }
  thirdFormVisible = false
  thirdParams: IAddApi = {
    firstId: '',
    secondId: '',
    name: '',
    method: 'GET',
    url: '',
    isAny: 0
  }
  updateFormVisible = false
  updateParams = { id: '', name: '', path: '', method: '' }
  rules = {
    name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
    url: [{ required: true, message: '请输入url', trigger: 'blur' }],
    path: [{ required: true, message: '请输入url', trigger: 'blur' }],
    method: [{ required: true, message: '请选择方法', trigger: 'change' }]
  }
  tempNode: any = {}
  tempData: any = {}
  tempName = ''
  // methods
  created() {
    this.initTree()
  }

  generateTree(routerList: any[], fisrtRouter: any, secondRouter: any) {
    this.treeList = generateTree(routerList, fisrtRouter, secondRouter)
  }

  async initTree() {
    this.tableLoading = true
    setTimeout(() => {
      this.tableLoading = false
    }, 1500)
    await this.getFirstRouterMap()
    await this.getSecondRouterMap()
    await this.getRouterList()
    this.generateTree(this.routerList, this.firstRouter, this.secondRouter)
  }

  async getFirstRouterMap() {
    let res: any = await getFirstRouterMap()
    this.firstRouter = res.data
  }

  async getSecondRouterMap() {
    let res: any = await getSecondRouterMap()
    this.secondRouter = res.data
  }

  async getRouterList() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    let groupId = userInfo.level
    let res: any = await getGroupRouterList({ groupId: 55 })
    this.routerList = res.data
  }

  async addFirstRouter() {
    let res: any = await addFirstRouter(this.firstParams)
    if (res.status.code === 0) {
      this['$message'].success('提交成功')
      console.log(res)
      const { id, name } = res.data
      this.handleAddFirstNode(id, name)
      this.cancelFirstForm()
    } else {
      this['$message'].error('提交失败,请稍后重试或联系相关管理员')
    }
  }

  async addSecondRouter() {
    let res: any = await addSecondRouter(this.secondParams)
    if (res.status.code === 0) {
      this['$message'].success('提交成功')
      const { id, name } = res.data
      this.handleAddNode(2, id, name, this.tempNode, this.tempData)
      this.cancelSecondForm()
    } else {
      this['$message'].error('提交失败,请稍后重试或联系相关管理员')
    }
  }

  async addThirdRouter() {
    let res: any = await addApiRouter(this.thirdParams)
    if (res.status.code === 0) {
      this['$message'].success('提交成功')
      console.log(res)
      const { option: name, id } = res.data
      this.handleAddNode(3, id, name, this.tempNode, this.tempData)
      this.cancelThirdForm()
    } else {
      this['$message'].error('提交失败,请稍后重试或联系相关管理员')
    }
  }

  async updateApiRouter() {
    let res:any = await updateApiRouter(this.updateParams)
    console.log(res)
    if (res.status.code === 0) {
      this['$message'].success('修改成功')
      this.tempData.name = this.updateParams.name
      this.cancelUpdateForm()
    } else {
      this['$message'].error('修改失败,请稍后重试或联系相关管理员')
    }
  }

  // 新增一级节点
  handleAddFirstRouter() {
    this.firstFormVisible = true
  }
  cancelFirstForm() {
    (this.$refs['FirstForm'] as Form).resetFields()
    this.firstFormVisible = false
  }
  confirmFirstForm() {
    (this.$refs['FirstForm'] as Form).validate(valid => {
      if (valid) {
        this.addFirstRouter()
      } else {
        this['$message'].warning('请填写缺失参数!')
        return false
      }
    })
  }
  handleAddFirstNode(id: string, name: string) {
    let temp = cloneDeep(this.initNode)
    temp['id'] = id.toString()
    temp['name'] = name
    this.treeList.push(temp)
  }

  // 新增二级节点
  cancelSecondForm() {
    (this.$refs['secondForm'] as Form).resetFields()
    this.secondFormVisible = false
  }
  confirmSecondForm() {
    (this.$refs['secondForm'] as Form).validate(valid => {
      if (valid) {
        this.addSecondRouter()
      } else {
        this['$message'].warning('请填写缺失参数!')
        return false
      }
    })
  }

  // 新增三级节点
  cancelThirdForm() {
    (this.$refs['ThirdForm'] as Form).resetFields()
    this.thirdFormVisible = false
  }
  confirmThirdForm() {
    (this.$refs['ThirdForm'] as Form).validate(valid => {
      if (valid) {
        this.addThirdRouter()
      } else {
        this['$message'].warning('请填写缺失参数!')
        return false
      }
    })
  }

  // 修改三级节点
  cancelUpdateForm() {
    (this.$refs['UpdateForm'] as Form).resetFields()
    this.updateFormVisible = false
  }
  confirmUpdateForm() {
    (this.$refs['UpdateForm'] as Form).validate(valid => {
      if (valid) {
        this.updateApiRouter()
      } else {
        this['$message'].warning('请填写缺失参数!')
        return false
      }
    })
  }

  // 新增节点
  handleAddRouter(node: any, data: any) {
    this.tempNode = node
    this.tempData = data
    console.log(node, data)
    let level = node.level
    if (level === 1) {
      // 新增level2
      this.secondFormVisible = true
      this.secondParams.firstId = data.id
    } else if (level === 2) {
      // 新增level3
      this.thirdFormVisible = true
      this.thirdParams.firstId = node.parent.data.id
      this.thirdParams.secondId = data.id
    }
  }

  // 删除节点
  handleDelete(node: any, data: any) {
    console.log(node.level, data)
    const { level } = node
    const { id } = data
    this.$confirm('是否删除此权限节点？', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res:any = {}
        if (level === 1) {
          res = await deleteFirstRouter({ id })
        } else if (level === 2) {
          res = await deleteSecondRouter({ id })
        } else if (level === 3) {
          res = await deleteApiRouter({ id })
        }
        if (res.status.code === 0) {
          deleteNode()
          this['$message'].success('删除成功!')
        } else {
          this['$message'].error('删除失败!')
        }
      })
      .catch(() => {})

    let deleteNode = () => {
      this.$nextTick(() => {
        if (this.$refs.SlotTree) {
          (this['$refs'].SlotTree as any).remove(data)
        }
      })
    }
  }

  // 修改节点: 1,2 级
  async handleInput(node: any, data: any) {
    console.log(node.level, data.name)
    const { name } = data
    const { level } = node
    if (!data.name) {
      this['$message'].warning('请输入有效名称!')
      data.name = this.tempName
      return
    }
    if (this.tempName !== name) {
      let res:any = {}
      let params = {
        id: data.id,
        name: data.name
      }
      res = level === 1 ? await updateFirstRouter(params) : await updateSecondRouter(params)
      if (res.status.code === 0) {
        this['$message'].success('修改成功!')
      } else {
        this['$message'].error('修改失败!')
      }
    } else {
      this['$message'].warning('名称重复!')
    }
    // 退出编辑状态
    if (node.isEdit) {
      this.$set(node, 'isEdit', false)
    }
  }
  // 编辑节点
  async handleEdit(node: any, data: any) {
    const { level } = node
    this.tempName = data.name
    if (level <= 2) { // 1,2级直接输入框修改
      // 设置编辑状态
      if (!node.isEdit) {
        this.$set(node, 'isEdit', true)
      }
      // 输入框聚焦
      this.$nextTick(() => {
        if (this.$refs['slotTreeInput' + data[this.NODE_KEY]]) {
          (this.$refs['slotTreeInput' + data[this.NODE_KEY]] as any).$refs.input.focus()
        }
      })
    } else { // 3 级则弹框修改
      this.updateFormVisible = true
      this.tempData = data
      console.log(data)
      const { id } = data
      let res:any = await getApiRouter({ id })
      if (res.status.code === 0) {
        this.updateParams.id = id
        this.updateParams.path = res.data.url
        this.updateParams.name = res.data.option
        this.updateParams.method = res.data.method
      }
    }
  }
  // 新增节点: 2级节点 & 3级节点
  handleAddNode(level: number, id: string, name: string, node: any, data: any) {
    let temp = cloneDeep(this.initNode)
    temp['pid'] = data['id']
    temp['id'] = id.toString()
    temp['name'] = name
    // 判断字段是否存在
    if (!data.children) {
      this.$set(data, 'children', [])
    }
    // 新增数据
    data.children.push(temp)
    // 展开节点
    if (!node.expanded) {
      node.expanded = true
    }
  }
}
